import { createFormState, required, isProbablyEmail } from "redux-freeform";
const formConfig = {
  client: {
    validators: [],
  },
  firstName: {
    validators: [required()],
  },
  lastName: {
    validators: [required()],
  },
  isActive: {
    validators: [],
  },
  email: {
    validators: [isProbablyEmail()],
  },
  role: {
    validators: [],
  },
  pos_role: {
    validators: [],
  },
  searchTerm: {
    validators: [],
  },
};

export const { reducer, mapStateToProps, mapDispatchToProps } =
  createFormState(formConfig);
